import getUserId from '../../selectors/view/get-user-id';
import getUserEmail from '../view/getUserEmail';

const getGAUserId = state =>
  JSON.stringify({ userId: getUserId(state), username: getUserEmail(state) });

export default getGAUserId;
